<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动</el-breadcrumb-item>
      <el-breadcrumb-item>抽奖记录</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
        <el-row :gutter="20">
            <el-col :span="3">
              <el-input v-model="queryInfo.id" placeholder="请输入记录编号" clearable></el-input>
            </el-col>
            <el-col :span="3">
              <el-input v-model="queryInfo.userId" placeholder="请输入用户id" clearable></el-input>
            </el-col>
            <el-col :span="1">
              <el-button type="primary" @click="getDrawHistoryList">查询</el-button>
            </el-col>
        </el-row>
        <el-table :data="tableInfo.tableData" border>
          <el-table-column
            v-for="(item,index) in tableInfo.columns"
            :prop="item.prop"
            :label="item.label"
            :align="item.align"
            :key="index"
          >
            <template slot-scope="scope">
              <span v-if="item.prop == 'createTime'">{{scope.row[item.prop] | filterTime}}</span>
              <span v-else-if="item.prop == 'isUse'">{{scope.row[item.prop] | filterOk}}</span>
              <span v-else>{{scope.row[item.prop]}}</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationInfo.pageNum"
        :page-sizes="[10,30,50]"
        :page-size="paginationInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationInfo.total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
    data(){
        return  {
            // 搜索内容
            queryInfo: {
              id: '',
              userId: ''
            },
            // 表格内容
            tableInfo: {
              columns: [
                { label: '编号',prop: 'id', width: 150, align: 'center' },
                { label: '活动商品id',prop: 'activityGoodsId', width: 150, align: 'center' },
                { label: '用户id',prop: 'userId', width: 150, align: 'center' },
                { label: '奖品名称',prop: 'title', width: 150, align: 'center' },
                { label: '是否使用',prop: 'isUse', width: 150, align: 'center' },
                { label: '创建时间',prop: 'createTime', width: 150, align: 'center' },
                // { label: '列6',prop: 'columnsSeven', width: 150, align: 'center' },
              ],
              tableData: []
            },
            // 分页
            paginationInfo: {
              pageNum: 1,
              pageSize: 10,
              total: 0
            }
        }
    },
    mounted(){
      this.getDrawHistoryList();
    },
    methods: {
      // 获取表格数据
      getDrawHistoryList(){
        const params = {
          pageNum: this.paginationInfo.pageNum,
          pageSize: this.paginationInfo.pageSize
        }
        for(let key in this.queryInfo){
          if(this.queryInfo[key]){
            params[key] = this.queryInfo[key];
          }
        }
        this.$http.get('/draw/list',{ params }).then((res)=>{
          this.tableInfo.tableData = res.data.data.result;
          this.paginationInfo.pageNum = res.data.data.currPage;
          this.paginationInfo.pageSize = res.data.data.pageSize;
          this.paginationInfo.total = res.data.data.total;
        })
      },

      // 切换页码
      handleSizeChange(newSize){
        this.paginationInfo.pageSize = newSize;
        this.getDrawHistoryList();
      },

      // 切换条数
      handleCurrentChange(newPage){
        this.paginationInfo.pageNum = newPage;
        this.getDrawHistoryList();
      }
    }

}
</script>

<style>

</style>
